import React, { useEffect, useRef, useState } from 'react'
import { useCart, useDispatchCart } from './ContextReducer';

export default function Card(props) {

    const priceRef = useRef();
    const data = useCart();
    const dispatch = useDispatchCart();
    const options = props.options;
    const priceOptions = Object.keys(options);
    const [qty, setqty] = useState(1)
    const [size, setsize] = useState("")

    const handleaddtocart = async () => {
        let food = []
        for (const item of data) {
            if (item.id === props.foodItem._id) {
                food = item;

                break;
            }
        }
        if (food !== []) {
            if (food.size === size) {
                await dispatch({ type: "UPDATE", id: props.foodItem._id, price: finalPrice, qty: qty })
                return
            }
            else if (food.size !== size) {
                await dispatch({
                    type: "ADD",
                    id: props.foodItem._id,
                    name: props.foodItem.name,
                    price: finalPrice,
                    qty: qty,
                    size: size,
                    img: props.foodItem.img
                })
                return
            }
            return
        }
        await dispatch({
            type: "ADD",
            id: props.foodItem._id,
            name: props.foodItem.name,
            price: finalPrice,
            qty: qty,
            size: size,
            img: props.foodItem.img
        })
        console.log(data);
    }
    const finalPrice = qty * parseInt(options[size]);
    useEffect(() => {
        setsize(priceRef.current.value)
    }, [])

    return (
        <div>
            <div className="card m-3 pd-2">
                <img src={props.foodItem.img} className="card-img-top" alt="..." style={{ height: "200px", objectFit: "fill" }} />
                <div className="card-body">
                    <h5 className="card-title">{props.foodItem.name}</h5>
                    <div className='w-100 card-100'>
                        <select className='m-2 h-100 bg-success' onChange={(e) => setqty(e.target.value)}>
                            {Array.from(Array(6), (e, i) => {
                                return (
                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                )
                            })}
                        </select>
                        <select className='m-2 h-100 bg-success' ref={priceRef} onChange={(e) => setsize(e.target.value)}>
                            {priceOptions.map((data) => {
                                return <option key={data} value={data}>{data}</option>
                            })}
                        </select>
                        <div className='d-inline h-100'>
                            {finalPrice}/-
                        </div>
                        <hr />
                        <button className='btn bg-success' onClick={handleaddtocart}>Add to cart</button>

                    </div> 
                </div>
            </div>
        </div>
    )
}
